export default vue => ({
  dataSource: [
    { id: 1, name: vue.$t('pending') },
    { id: 2, name: vue.$t('approved') },
    { id: 3, name: vue.$t('declined') },
  ],
  valueExpr: 'id',
  displayExpr: 'name',
});
